export interface PainBlock {
  emoji: string
  title: string
  intro?: string[]
  items?: string[]
  outro?: string[]
}

export const painIntro = [
  'Ami insegnare inglese.',
  'Ma insegnare è solo una parte del lavoro.',
  'Prima di ogni lezione devi decidere cosa fare, trovare il materiale giusto, preparare esercizi, scegliere attività, adattare il livello e organizzare tutto in una sequenza che funzioni davvero.',
  'E settimana dopo settimana, ricominci da capo.',
]

export const painBlocks: PainBlock[] = [
  {
    emoji: '😩',
    title: 'PASSI TROPPO TEMPO A PREPARARE LE LEZIONI',
    items: [
      'Quale argomento affrontare?',
      'Quale attività utilizzare?',
      'Come iniziare la lezione?',
      'Come praticare la grammatica?',
      'Quali domande usare per lo speaking?',
      'Come lavorare sul vocabolario?',
      'Cosa assegnare come compito?',
      'Come verificare i progressi?',
    ],
    outro: [
      'Una singola lezione può richiedere molto più tempo di preparazione di quanto dovrebbe.',
    ],
  },
  {
    emoji: '📚',
    title: 'HAI GIÀ TANTISSIMO MATERIALE... MA È TUTTO SPARSO',
    items: [
      'Schede.',
      'Documenti.',
      'Attività salvate.',
      'Vecchie lezioni.',
      'Esercizi.',
      'Appunti.',
      'Risorse trovate nel tempo.',
    ],
    outro: [
      'Probabilmente possiedi già moltissimo materiale.',
      'Il problema è trovare quello giusto, per il livello giusto, nel momento giusto.',
      'Continui a cercare, selezionare, modificare e organizzare.',
      'Quello che manca non è altro materiale casuale.',
      'È un unico sistema organizzato e pronto all’uso.',
    ],
  },
  {
    emoji: '🗣️',
    title: 'OGNI LEZIONE HA BISOGNO DI QUALCOSA DI DIVERSO',
    intro: ['Un giorno devi lavorare sulla grammatica.', 'Un altro sul vocabolario.'],
    items: [
      'Poi speaking.',
      'Reading.',
      'Writing.',
      'Pronunciation.',
      'Conversation.',
      'Review.',
      'Assessment.',
    ],
    outro: [
      'E non puoi utilizzare sempre la stessa struttura o improvvisare ogni volta.',
      'Hai bisogno di una libreria abbastanza completa da permetterti di scegliere rapidamente ciò che serve.',
    ],
  },
  {
    emoji: '⏰',
    title: 'IL LAVORO CONTINUA ANCHE DOPO LA LEZIONE',
    intro: ['Finita la lezione devi ancora...'],
    items: [
      'Controllare gli esercizi.',
      'Assegnare attività.',
      'Registrare i progressi.',
      'Correggere gli errori.',
      'Preparare il lavoro successivo.',
      'Adattare il livello.',
      'Organizzare la prossima lezione.',
    ],
    outro: ['E poi tutto ricomincia.'],
  },
]
